import { Component } from '@angular/core';

// Shell for the invitations tab. Hosts the nested route: the invite list (default)
// and the invite details page (child route by announcement id).
@Component({
    selector: 'app-jobseeker-invites',
    templateUrl: './jobseeker-invites.component.html',
    styleUrls: ['./jobseeker-invites.component.scss'],
    standalone: false
})
export class JobseekerInvitesComponent { }
